import { RoutingActions } from '@state/slices/app/routing';
import { createSlice } from '@reduxjs/toolkit';

export const INITIAL_HISTORY_STATE: Array<string> = [];

const historySlice = createSlice({
  name: 'history',
  initialState: INITIAL_HISTORY_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(RoutingActions.INITIALIZE_PATH, (state: Array<string> = INITIAL_HISTORY_STATE, action: any) => {
      if (state[state.length - 1] !== action.payload) {
        state.push(action.payload);
        if (state.length > 10) {
          state.shift();
        }
      }
    });
  }
});

export const historyReducer = historySlice.reducer;
